// extracted by mini-css-extract-plugin
module.exports = {"container":"LineDummy_container__1FDEg","horizontal":"LineDummy_horizontal__2xw-S","dummy1":"LineDummy_dummy1__1DMDY","dummy2":"LineDummy_dummy2__1hI6i"};